import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import DownloadModal from "@/components/DownloadModal";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Upload from "@/pages/Upload";
import RawQuestions from "@/pages/RawQuestions";
import Batches from "@/pages/Batches";
import BatchDetail from "@/pages/BatchDetail";
import Tags from "@/pages/Tags";
import Users from "@/pages/Users";
import ReviewedQueue from "@/pages/ReviewedQueue";
import AuditLog from "@/pages/AuditLog";
import Lookups from "@/pages/Lookups";
import Exports from "@/pages/Exports";

import {
  ADMIN_ROLES,
  ADMIN_AND_COORDINATOR,
  USERS_PAGE_ROLES,
} from "@/lib/roles";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/upload"
              element={
                <ProtectedRoute roles={ADMIN_ROLES}>
                  <Upload />
                </ProtectedRoute>
              }
            />
            <Route
              path="/questions"
              element={
                <ProtectedRoute roles={ADMIN_AND_COORDINATOR}>
                  <RawQuestions />
                </ProtectedRoute>
              }
            />
            <Route path="/batches" element={<Batches />} />
            <Route path="/batches/:id" element={<BatchDetail />} />
            <Route
              path="/qc"
              element={
                <ProtectedRoute roles={ADMIN_ROLES}>
                  <ReviewedQueue />
                </ProtectedRoute>
              }
            />
            <Route
              path="/exports"
              element={
                <ProtectedRoute roles={ADMIN_ROLES}>
                  <Exports />
                </ProtectedRoute>
              }
            />
            <Route path="/activity" element={<AuditLog />} />
            <Route
              path="/lookups"
              element={
                <ProtectedRoute roles={ADMIN_ROLES}>
                  <Lookups />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tags"
              element={
                <ProtectedRoute roles={ADMIN_ROLES}>
                  <Tags />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute roles={USERS_PAGE_ROLES}>
                  <Users />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <DownloadModal />
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
